import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/member/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/member/createManageMember', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/member/updateMangerById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/member/delete/${id}`)
}
